<ion-content>
  <div class="constrained-content">
    <ion-grid class="constrained-content">
      <ion-row>
        <ion-col size-md="4" size="12" class="settings-title-section">
          <h1><ion-icon name="folder-open-outline"></ion-icon>Projects</h1>
          <p class="subtitle">
            Group customers, conversations and settings into projects. This allows you to set different permissions,
            ticket types, and reporting for groups of channels and conversations.
          </p>
          <p class="subtitle" style="opacity: 1; margin-bottom: 15px">
            <a href="https://docs.unthread.io/account-setup/projects-permissions" target="_blank">
              Learn more about projects
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </a>
          </p>
        </ion-col>
        <ion-col size-md="8" size="12">
          <div class="flex-space-between" style="padding: 15px 5px 0 3px">
            <div class="button-container flexed-align-center">
              <ion-searchbar
                mode="ios"
                placeholder="Search..."
                showCancelButton="never"
                [(ngModel)]="searchText"
                (ionChange)="handleFilters()"
                class="rounded-search-bar"
              >
              </ion-searchbar>
            </div>

            <div class="button-container flexed-align-center">
              <ion-button (click)="createProject()" *ngIf="authService.isTenantAdmin">
                <ion-icon name="add-outline"></ion-icon>
                <span class="text-with-left-icon hidden-sm"> Create project </span>
              </ion-button>
            </div>
          </div>
          <ion-card class="outline-card" style="margin: 18px">
            <ngx-datatable
              class="material"
              columnMode="force"
              [limit]="100"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="50"
              [scrollbarH]="true"
              [rows]="filteredProjects"
              [reorderable]="true"
            >
              <ngx-datatable-column name="Name" prop="name" [minWidth]="100" [width]="200">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <a style="font-weight: 500" (click)="editProject(row.id)">{{ value }}</a>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Description" prop="description" [minWidth]="100">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Visibility" prop="visibility" [minWidth]="120" [maxWidth]="120">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ value | titlecase }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Type" prop="isExternal" [minWidth]="150" [maxWidth]="120">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ value ? 'External Support' : 'Internal Support' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Triage Channel"
                prop="defaultTriageChannelId"
                [minWidth]="150"
                [maxWidth]="120"
              >
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ value ? channelName(value) : 'Default' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Support Team" prop="hasSupportTeamProps" [minWidth]="150" [maxWidth]="120">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ value ? 'Custom' : 'Default' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Created at" prop="createdAt" [minWidth]="120" [maxWidth]="120">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ value | date: 'M/d/yyyy' }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
